import { useEffect } from "react";
import { FiMenu, FiX } from "react-icons/fi";
import { Link, useLocation } from "react-router";
import { primaryNavigation } from "@/content/navigation";
import { buttonClass } from "@/components/ui/Button";
import { useUiStore } from "@/stores/ui-store";
import { Logo } from "./Logo";

export function Header() {
  const { pathname } = useLocation();
  const mobileMenuOpen = useUiStore((state) => state.mobileMenuOpen);
  const setMobileMenuOpen = useUiStore((state) => state.setMobileMenuOpen);
  const toggleMobileMenu = useUiStore((state) => state.toggleMobileMenu);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [pathname, setMobileMenuOpen]);

  return (
    <header className="sticky top-0 z-50 border-b border-line bg-paper/92 backdrop-blur">
      <div className="container-site flex min-h-20 items-center justify-between gap-4">
        <Logo />

        <nav className="hidden items-center gap-1 md:flex" aria-label="Primary">
          {primaryNavigation.map((item) => {
            const active = pathname === item.href;

            return (
              <Link
                key={item.href}
                to={item.href}
                aria-current={active ? "page" : undefined}
                className={`inline-flex min-h-11 items-center rounded-full px-4 text-sm font-semibold transition ${
                  active
                    ? "bg-brand-100 text-brand-950"
                    : "text-ink-soft hover:bg-brand-100/70 hover:text-brand-950"
                }`}
              >
                {item.label}
              </Link>
            );
          })}
        </nav>

        <div className="flex items-center gap-2">
          <Link
            to="/contact"
            className={`${buttonClass("primary", "hidden md:inline-flex")} text-sm`}
          >
            Request a demo
          </Link>
          <button
            type="button"
            className="inline-flex min-h-11 min-w-11 items-center justify-center rounded-full border border-line bg-surface md:hidden"
            aria-expanded={mobileMenuOpen}
            aria-controls="mobile-menu"
            onClick={toggleMobileMenu}
          >
            <span className="sr-only">{mobileMenuOpen ? "Close menu" : "Open menu"}</span>
            {mobileMenuOpen ? (
              <FiX aria-hidden="true" className="size-5" />
            ) : (
              <FiMenu aria-hidden="true" className="size-5" />
            )}
          </button>
        </div>
      </div>

      {mobileMenuOpen ? (
        <div id="mobile-menu" className="border-t border-line bg-surface md:hidden">
          <nav className="container-site grid gap-1 py-4" aria-label="Mobile">
            {primaryNavigation.map((item) => (
              <Link
                key={item.href}
                to={item.href}
                className="flex min-h-12 flex-col justify-center rounded-xl px-3 hover:bg-brand-100/60"
              >
                <span className="font-semibold">{item.label}</span>
                <span className="text-sm text-ink-soft">{item.description}</span>
              </Link>
            ))}
            <Link to="/contact" className={`${buttonClass("primary", "mt-3 w-full")} text-sm`}>
              Request a demo
            </Link>
          </nav>
        </div>
      ) : null}
    </header>
  );
}
